const GrantBenForm = () => {
  return (
    <>
      Hello World from GBF!!
    </>
  )
}

export default GrantBenForm;